import { Component, Input } from "@angular/core";

@Component({
  selector: "app-client-info-section-item",
  templateUrl: "./client-info-section-item.component.html",
  styleUrls: ["./client-info-section-item.component.scss"],
})
export class ClientInfoSectionItemComponent {
  @Input() label = "";
  @Input() value = "";
  @Input() isLoading = false;
}
